export default __webpack_public_path__ + "static/media/Yellow0007.33e8778c.png";